/** @format */

export class Badge {
	type = 'none';
	backgroundColor: string;
	foregroundColor: string;

	constructor(badgeType: string, backgroundColor?: string, foregroundColor?: string) {
		this.type = badgeType;
		this.backgroundColor = backgroundColor;
		this.foregroundColor = foregroundColor;
	}
}
